"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.EhrLoginLogout = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _react = _interopRequireDefault(require("react"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _banner = _interopRequireDefault(require("@kyruus/banner"));
var _button = require("@kyruus/button");
var _ThirdPartyBanners = require("../../ThirdPartyBanners");
var _EhrLoginLogout = require("./EhrLoginLogout.styles");
var _propTypes = require("prop-types");
var _thirdPartyLoginUtils = require("../../../lib/thirdPartyLoginUtils");
var _thirdPartyLogin = require("../../../lib/constants/thirdPartyLogin");
var _Tracking = require("../../../lib/constants/Tracking");
const EhrLoginLogout = _ref => {
  let {
    intl,
    loginProps,
    callbackProps = {},
    track
  } = _ref;
  const {
    isLoggedIn,
    login,
    logout,
    errors = [],
    type
  } = loginProps;
  const isLoginEnabled = _react.default.useMemo(() => !(0, _isEmpty.default)(loginProps) && !(0, _isEmpty.default)(login) && !(0, _isEmpty.default)(logout), [loginProps, login, logout]);
  const handleLogin = _react.default.useCallback(e => {
    e.preventDefault();
    if (login.callback) {
      track(_Tracking.userEvents.PATIENT_REG_EHR_LOGIN, {
        ehr: type
      });
      login.callback(callbackProps);
    }
  },
  // callbackProps is small enough that JSON.stringify won't be slow, lets us deep compare
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [(0, _stringify.default)(callbackProps), login, track, type]);
  const handleLogout = _react.default.useCallback(e => {
    e.preventDefault();
    if (logout.callback) {
      logout.callback(callbackProps);
    }
  },
  // callbackProps is small enough that JSON.stringify won't be slow, lets us deep compare
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [(0, _stringify.default)(callbackProps), logout]);
  if (!isLoginEnabled) return null;
  if (errors.length > 0) {
    const {
      description: messageText,
      action: actionText
    } = (0, _thirdPartyLoginUtils.getErrorMessageWithIntl)({
      thirdPartyLoginProps: loginProps,
      intl
    });
    if (!messageText) return null;
    return /*#__PURE__*/_react.default.createElement(_ThirdPartyBanners.AuthNBanner, {
      "data-testid": "auth-banner-error",
      description: messageText,
      action: actionText
    }, _ref2 => {
      let {
        description,
        action
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement(_banner.default, {
        "data-testid": "auth-banner-error-button",
        type: "warning",
        icon: "!",
        action1Text: action,
        action1: action ? handleLogin : undefined
      }, description);
    });
  }
  return isLoggedIn ? /*#__PURE__*/_react.default.createElement(_ThirdPartyBanners.AuthNBanner, {
    "data-testid": "auth-banner-logout",
    description: logout.description,
    action: logout.action
  }, _ref3 => {
    let {
      description,
      action
    } = _ref3;
    return /*#__PURE__*/_react.default.createElement(_banner.default, {
      "data-testid": "auth-banner-logout-button",
      type: "success",
      icon: "check",
      action1Text: action,
      action1: handleLogout
    }, description);
  }) : /*#__PURE__*/_react.default.createElement(_ThirdPartyBanners.AuthNBanner, {
    "data-testid": "auth-banner-login",
    header: /*#__PURE__*/_react.default.createElement(_EhrLoginLogout.LoginHeader, null, login.header),
    description: /*#__PURE__*/_react.default.createElement(_EhrLoginLogout.LoginDescription, null, login.description),
    action: /*#__PURE__*/_react.default.createElement(_button.ButtonLink, {
      mode: "primary",
      "data-testid": "auth-banner-login-button",
      href: login.url,
      onClick: handleLogin
    }, login.action),
    separatorContent: login.separator
  });
};
exports.EhrLoginLogout = EhrLoginLogout;
EhrLoginLogout.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  intl: (0, _propTypes.shape)({
    locale: _propTypes.string.isRequired,
    formatMessage: _propTypes.func.isRequired
  }).isRequired,
  loginProps: (0, _propTypes.shape)({
    isLoggedIn: _propTypes.bool.isRequired,
    login: (0, _propTypes.shape)({
      url: _propTypes.string,
      callback: _propTypes.func.isRequired,
      header: _propTypes.string,
      description: _propTypes.string,
      action: _propTypes.string.isRequired,
      separator: _propTypes.string
    }).isRequired,
    logout: (0, _propTypes.shape)({
      url: _propTypes.string,
      callback: _propTypes.func.isRequired,
      header: _propTypes.string,
      description: _propTypes.string,
      action: _propTypes.string.isRequired,
      separator: _propTypes.string
    }).isRequired,
    errors: (0, _propTypes.arrayOf)((0, _propTypes.oneOf)((0, _values.default)(_thirdPartyLogin.ERROR))),
    type: _propTypes.string.isRequired
  }),
  callbackProps: _propTypes.object,
  track: _propTypes.func.isRequired
};
EhrLoginLogout.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EhrLoginLogout",
  "props": {
    "callbackProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "locale": {
            "name": "string",
            "required": true
          },
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    },
    "loginProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "isLoggedIn": {
            "name": "bool",
            "required": true
          },
          "login": {
            "name": "shape",
            "value": {
              "url": {
                "name": "string",
                "required": false
              },
              "callback": {
                "name": "func",
                "required": true
              },
              "header": {
                "name": "string",
                "required": false
              },
              "description": {
                "name": "string",
                "required": false
              },
              "action": {
                "name": "string",
                "required": true
              },
              "separator": {
                "name": "string",
                "required": false
              }
            },
            "required": true
          },
          "logout": {
            "name": "shape",
            "value": {
              "url": {
                "name": "string",
                "required": false
              },
              "callback": {
                "name": "func",
                "required": true
              },
              "header": {
                "name": "string",
                "required": false
              },
              "description": {
                "name": "string",
                "required": false
              },
              "action": {
                "name": "string",
                "required": true
              },
              "separator": {
                "name": "string",
                "required": false
              }
            },
            "required": true
          },
          "errors": {
            "name": "arrayOf",
            "value": {
              "name": "enum",
              "computed": true,
              "value": "Object.values(THIRD_PARTY_LOGIN_ERROR)"
            },
            "required": false
          },
          "type": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": false
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};